import { render, staticRenderFns } from "./Nomina.vue?vue&type=template&id=fa7ed06e&"
import script from "./Nomina.vue?vue&type=script&lang=js&"
export * from "./Nomina.vue?vue&type=script&lang=js&"
import style0 from "./Nomina.vue?vue&type=style&index=0&id=fa7ed06e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports